export const heroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/44f9af58-b0eb-4a39-b782-ce5d22f8c570.jpg';
export const cardImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/7b233853-d3d6-48a0-8273-3fb7d8ac8ced.jpg';
export const landImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/fe64f802-f506-43a3-9dcb-f84107eebfb5.jpg';

export const quickActions = [
  { label: 'Ouvrir un compte', hint: 'En agence ou en ligne', path: '/devenir-client', icon: 'user' },
  { label: 'Demander un crédit', hint: 'Réponse rapide', path: '/particuliers/credits', icon: 'credit' },
  { label: 'Trouver une agence', hint: 'Partout en Mauritanie', path: '/la-banque/agences', icon: 'map' },
  { label: 'Chinguitty Online', hint: 'Banque en ligne 24h/24', path: '/acces-comptes', icon: 'online' },
] as const;

export const audiences = [
  {
    title: 'Particuliers',
    text: 'Comptes, épargne, crédits et cartes pour accompagner chaque étape de votre vie.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/cbff68e1-cc90-4f72-ba34-2ddb9b1b0cf0.jpg',
    path: '/particuliers',
    links: [
      { label: 'Comptes courants', path: '/particuliers/comptes' },
      { label: 'Épargne', path: '/particuliers/epargne' },
      { label: 'Cartes GIMTEL', path: '/particuliers/cartes' },
      { label: 'Transferts', path: '/particuliers/transferts' },
    ],
  },
  {
    title: 'Entreprises & Professionnels',
    text: "Financement, trésorerie et commerce international pour faire grandir votre activité.",
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/07f46d55-cbef-4222-9991-f7d0f6560764.jpg',
    path: '/entreprises',
    links: [
      { label: 'Comptes professionnels', path: '/entreprises/comptes' },
      { label: 'Financement', path: '/entreprises/financement' },
      { label: 'Commerce international', path: '/entreprises/international' },
      { label: 'Cautions & garanties', path: '/entreprises/cautions' },
    ],
  },
];

export const credits = [
  { name: 'Prêt personnel', text: 'Financez vos projets personnels avec des mensualités adaptées à vos revenus.', path: '/particuliers/credits' },
  { name: 'Crédit renouvelable', text: 'Une réserve d’argent disponible, qui se reconstitue au fil de vos remboursements.', path: '/particuliers/credits' },
  { name: 'Crédit auto', text: 'Achetez votre véhicule neuf ou d’occasion sans attendre.', path: '/particuliers/credits' },
  { name: 'Prêt travaux', text: 'Construisez, rénovez ou agrandissez votre logement.', path: '/particuliers/credits' },
];

export const elHacadGoals = [
  'Réaliser un projet',
  'Financer les études des enfants',
  'Préparer la retraite',
  'Faire face à un imprévu',
  'Constituer un capital',
];

export const islamicProducts = [
  { name: 'Mourabaha', text: 'Financement d’acquisition à marge connue.' },
  { name: 'Ijara', text: 'Location avec option d’achat.' },
  { name: 'Moucharaka', text: 'Partenariat avec partage des résultats.' },
];

export const digitalServices = [
  {
    name: 'Chinguitty Online',
    text: 'Consultez vos soldes, téléchargez vos relevés et effectuez vos virements depuis votre ordinateur.',
    path: '/digital/chinguitty-online',
  },
  {
    name: 'Chinguitty SMS',
    text: 'Recevez vos alertes de mouvements et votre solde directement par SMS, sans connexion internet.',
    path: '/digital/chinguitty-sms',
  },
  {
    name: 'La carte GIMTEL',
    text: 'Retirez et payez sur l’ensemble du réseau interbancaire GIMTEL en Mauritanie.',
    path: '/particuliers/cartes',
  },
];

export const news = [
  {
    date: '12 oct. 2026',
    category: 'Produit',
    title: 'Découvrez le nouveau compte El-Haçad, l’épargne islamique pensée pour vos objectifs',
    path: '/la-banque/actualites',
  },
  {
    date: '28 sept. 2026',
    category: 'Immobilier',
    title: 'Vente de terrains : de nouveaux lots disponibles à Nouakchott',
    path: '/vente-de-terrains',
  },
  {
    date: '05 sept. 2026',
    category: 'Sécurité',
    title: 'Nos conseils pour protéger vos codes et éviter les tentatives de fraude',
    path: '/digital/securite',
  },
];
